import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Paper } from "@mui/material";
import { GroupingTable } from "../../../../components/Table/grouping_table";

export const TablaFormatos = ({ rows, copy }) => {
  const navigate = useNavigate();
  const sort = {};

  const redirect = (row) => {
    if (row) {
      navigate("/inventarios/etiquetas/" + row.foet_id);
    }
  };
  const columns = [
    {
      accessorKey: "foet_nombre",
      accessorFn: (row) =>
        row.foet_nombre ? (
          <span onClick={() => redirect(row)}>{row.foet_nombre}</span>
        ) : null,
      header: "Nombre",
    },
    {
      accessorKey: "foet_descripcion",
      accessorFn: (row) =>
        row.foet_descripcion ? (
          <span onClick={() => redirect(row)}>{row.foet_descripcion}</span>
        ) : null,
      header: "Descripción",
    },
    {
      accessorFn: (row) =>
        row?.foet_id ? (
          <Button
            variant="contained"
            className="btn_system"
            sx={{ width: "120px" }}
            onClick={() => copy(row.foet_id)}
          >
            Copiar
          </Button>
        ) : (
          ""
        ),
      id: "copiar",
      header: "",
    },
  ];

  return (
    <Paper style={{ height: "75vh", width: "100%" }} sx={{ boxShadow: "none" }}>
      <GroupingTable
        key="tabla_etiquetas"
        columnas={columns}
        data={rows}
        redirect={() => console.log("redirect")}
        sort={sort}
      />
    </Paper>
  );
};
